
import { defineComponent, ref, inject, provide, onMounted} from 'vue';
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";

import ModalListPersons from '@/components/modals/general/ModalListPersons.vue';
import ModalRegister from '../tournaments/Modals/ModalRegister.vue';
import { errManager, showNotification } from '@/core/config/Tools';
import eventService from '@/core/services/EventService';
import GlobalService from '@/core/services/GlobalService';
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
    components:{ ModalListPersons, ModalRegister },
    props:{
        event: {
            type: null,
            required: false,
            default: {}
        },
        activity: {
            type: null,
            required: true,
            default: {}
        },
    },
    setup(props) {
        const { t } = useI18n();
        const store = useStore();
        const loader = ref(false);
        const action = ref(0);
        const gblDialog = inject<any>('gblDialog');
        const gblDialogAcrd = ref<any>(false);
        const rowAcrd = ref<any>({});
        const listSetting = ref<any>({}); //lista de configuraciones
        const listNominal = ref<any>([]);
        provide('gblDialogAcrd', gblDialogAcrd);
        provide('rowAcrd', rowAcrd);

        const openModalSelectPersons = async() => {
            store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
            await GlobalService.get('api/events', `${props.event.idevent}/deadline`)
            .then((res)=>{
                store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
                if(res.data.status === 'success')
                    gblDialog.value = true;
                else 
                    showNotification(res.data);
            }).catch(({response})=>{
                store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
                errManager(response)
            }).finally(()=>{
                store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
            })
        };

        const getSelectRow = (data) => {
            Object.assign(rowAcrd.value, data, { tregister: 'ASI' }, { idevent: props.event.idevent }, { idsport: props.activity.idsport })
            action.value = 1
            gblDialogAcrd.value = true
        };

        //metodo de respuesta modal register acrd
        const onResponse = (data) => {
            if (data.status == 'success') {
                getListNominal()
            }
        }

        const getListNominal = async () => {
            listNominal.value.length = 0
            loader.value = true
            await eventService.getNominal({
                idevent: props.event.idevent,
                idsport: props.activity.idsport,
                checkdoc: [0,1,2,3,4,5],
                type_register: "ASI",
                idteam: false,
                idinstitution : null
            })
                .then((res) => {
                    listNominal.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false;
                    errManager(response)
                })
        };

        const onDelete = (row) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: t('deleteText', {text: `<b>${row.firstname} ${row.lastname}</b>`}),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                showLoaderOnConfirm: true,
                reverseButtons: true,
                preConfirm: () => {
                    return GlobalService.delete('acreditation', `${row.idacreditation}/delete`)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    if (result.value.status === 'success') {
                        getListNominal();
                    }
                    //result.value.status === 'success' && 
                }
            })
        }

        onMounted(()=>{
            getListNominal();
        })

        return {
            t,
            loader,
            action,
            listSetting,
            listNominal,
            //events
            openModalSelectPersons,
            getSelectRow,
            onResponse,
            onDelete
        }

    },
})
